import type { PublicApiKey } from '#packages/apilib';
import type { createFloatingBubbleApi } from './floatingBubbleWrapper';

export const FloatingBubbleApiKey: PublicApiKey<
  typeof createFloatingBubbleApi
> = {
  name: 'FloatingBubbleApi',
  public: true,
};
